import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import StyledButton from "./StyledButton";
import StyledPaper from "./StyledPaper";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import appRoutes from "../utils/routes";

const SecondaryHeader: React.FC<{ title?: string }> = (props) => {
    return <Box display={'flex'}>
        <StyledPaper sx={{ padding: 0, height: 48, width: 48 }}>
            <Link style={{ height: '100%', width: '100%' }} to={appRoutes.checkout}>
                <StyledButton sx={{ minWidth: 'unset', height: '100%', width: '100%' }}>
                    <ArrowBackIcon />
                </StyledButton>
            </Link>
        </StyledPaper>
        <Box flexGrow={1} display={'flex'} justifyContent={'center'} alignItems={'center'}>
            <Typography>{props.title}</Typography>
        </Box>
    </Box>
}

export default SecondaryHeader;